// window.addEventListener("load", function() {
    // //=require '../../../node_modules/bootstrap/js/dist/util.js'
    // //=require '../../../node_modules/bootstrap/js/dist/collapse.js'
    // //=require '../../../node_modules/bootstrap/js/dist/tooltip.js'
    // //=require '../../../node_modules/bootstrap/js/dist/modal.js'
// });